import { AppStateContext, AppStateProvider } from "AppState";
import { KeyboardContainerProvider } from "components/common/Keyboard/Keyboard.container";
import ActivationGate, {
  ActivationGateContext
} from "components/Gates/ActivationGate";
import ApiGate from "components/Gates/ApiGate";
import ConfigurationLoaderGate, {
  ConfigurationLoaderContext
} from "components/Gates/ConfigurationLoaderGate";
import CustomerDataGate from "components/Gates/CustomerDataGate";
import DeviceIdCtxProvider from "components/Gates/DeviceIdCtxProvider";
import LockGate from "components/Gates/LockGate";
import NetworkGate from "components/Gates/NetworkGate";
import TabletDataGate from "components/Gates/TabletDataGate";
import TabletStartupDataGate from "components/Gates/TabletStartupGate";
import TenantDataGate from "components/Gates/TenantDataGate";
import UpdateManager from "components/UpdateManager/UpdateManager";
import { History } from "history";
import * as React from "react";
import { OnboardingContainerProvider } from "screens/Onboarding/Onboarding.container";
import { ThemeProvider } from "themes";
import theme, { GlobalStyle } from "themes/simple-theme";

interface IProps {
  className?: string;
  history: History;
  children: any;
}

const INACTIVITY_DURATION_DEFAULT = 30000;

export default ({ children, history, className }: IProps): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <>
        <GlobalStyle />
        <div className={className}>
          <NetworkGate>
            <DeviceIdCtxProvider>
              <UpdateManager>
                <ConfigurationLoaderGate>
                  <ConfigurationLoaderContext.Consumer>
                    {config =>
                      config && (
                        <ActivationGate config={config} history={history}>
                          <ActivationGateContext.Consumer>
                            {access =>
                              access && (
                                <ApiGate
                                  apiUrl={config.api_url}
                                  access={access}
                                >
                                  <TabletStartupDataGate>
                                    <TenantDataGate>
                                      <TabletDataGate access={access}>
                                        <CustomerDataGate>
                                          <KeyboardContainerProvider>
                                            <AppStateProvider>
                                              <OnboardingContainerProvider>
                                                <LockGate
                                                  history={history}
                                                  inactivityPermittedDuration={
                                                    config.inactivity_permitted_duration ||
                                                    INACTIVITY_DURATION_DEFAULT
                                                  }
                                                >
                                                  {children}
                                                </LockGate>
                                              </OnboardingContainerProvider>
                                            </AppStateProvider>
                                          </KeyboardContainerProvider>
                                        </CustomerDataGate>
                                      </TabletDataGate>
                                    </TenantDataGate>
                                  </TabletStartupDataGate>
                                </ApiGate>
                              )
                            }
                          </ActivationGateContext.Consumer>
                        </ActivationGate>
                      )
                    }
                  </ConfigurationLoaderContext.Consumer>
                </ConfigurationLoaderGate>
              </UpdateManager>
            </DeviceIdCtxProvider>
          </NetworkGate>
        </div>
      </>
    </ThemeProvider>
  );
};



// WEBPACK FOOTER //
// ./src/App.tsx